exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:400,700,900);", ""]);

// module
exports.push([module.id, "#map[data-v-26c8c533]{-webkit-box-shadow:rgba(0,0,0,.15) 0 0 15px;box-shadow:0 0 15px rgba(0,0,0,.15);width:100%;height:100%;min-height:100vh}@media (min-width:1201px){#map[data-v-26c8c533]{width:calc(100% - 680px);float:right}#map.bigger[data-v-26c8c533]{width:calc(100% - 410px)}}@media screen and (max-height:500px){#map[data-v-26c8c533]{min-height:500px}}", ""]);

// exports
